<template>
  <SoDialog
    v-model="value"
    :max-width="1200"
    card-title="IHD Troubleshooting"
    data-testid="ihd-troubleshooting-modal"
  >
    <div ref="typeformWrapper" class="ihd-troubleshooting-modal"></div>
  </SoDialog>
</template>

<script lang="ts">
  import { defineComponent } from "vue"
  import { typeformIds } from "@/constants/typeformIds"
  import SoDialog from "@/components/SoDialog.vue"
  import TypeformService from "@/services/TypeformService"

  export default defineComponent({
    components: {
      SoDialog,
    },
    props: {
      modelValue: {
        type: Boolean,
        default: false,
        required: true,
      },
    },
    emits: ["update:modelValue"],
    data() {
      return {
        typeformIds,
      }
    },
    computed: {
      value: {
        get() {
          return this.modelValue
        },
        set(value: boolean) {
          this.$emit("update:modelValue", value)
        },
      },
    },
    watch: {
      modelValue(value) {
        if (value) {
          setTimeout(() => {
            this.loadTypeform()
          }, 100)
        }
      },
    },
    methods: {
      loadTypeform() {
        TypeformService.openWidget(typeformIds.IHD_TROUBLESHOOTING, {
          container: this.$refs.typeformWrapper,
          inlineOnMobile: true,
          onReady: async () => {
            await new Promise((resolve) => setTimeout(resolve, 1000))
          },
        })
      },
    },
  })
</script>

<style>
  .ihd-troubleshooting-modal {
    width: 100%;
    height: 700px;
  }
</style>
